import React, { useState } from "react";
import { ReactComponent as ArrowDown } from "assets/img/icons/arrowdown.svg";
import { ReactComponent as ArrowUp } from "assets/img/icons/arrowup.svg";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";
import classNames from "classnames";
import { Scrollbar } from "react-scrollbars-custom";

export default ({
  dropDownData,
  onClick,
  name,
  parentClassName = null,
  dropDownStyle,
  clidClassName = null,
  contentStyle,
  headerStyle,
  optionStyle,
  headerClassName,
  displayArrow = true,
}) => {
  const [dropDownState, setDropDown] = useState();

  const dropDownClasses = classNames({
    generalTeamDropdown: true,
    [parentClassName]: true,
  });

  const dropDownContent = classNames({
    generalTeamNames: true,
    [clidClassName]: true,
  });

  const dropDownHeader = classNames({
    dropDownHeader: true,
    [headerClassName]: true,
  });

  const handleDropDown = () => {
    setDropDown(!dropDownState);
  };

  return (
    <ClickAwayListener onClickAway={() => setDropDown(false)}>
      <div
        style={dropDownStyle}
        onClick={handleDropDown}
        className={dropDownClasses}
      >
        <div className={dropDownHeader} style={headerStyle}>
          <span>{name}</span>
          {displayArrow && (
            <span>
              {!dropDownState && <ArrowDown style={{ fill: "#000000ab" }} />}
              {dropDownState && (
                <ArrowUp
                  style={{ fill: "#000000ab", width: "24px", height: "24px" }}
                />
              )}
            </span>
          )}
        </div>
        <CSSTransition
          in={dropDownState}
          timeout={300}
          unmountOnExit
          classNames="dropdown-element"
        >
          <div className={dropDownContent} style={contentStyle}>
            <Scrollbar
              translateContentSizeYToHolder={true}
              style={{
                maxHeight: "calc(100vh - 485px)",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                {dropDownData?.map((data, index) => (
                  <span
                    key={index}
                    onClick={() => onClick(data)}
                    style={optionStyle}
                  >
                    {data.name}
                  </span>
                ))}
              </div>
            </Scrollbar>
          </div>
        </CSSTransition>
      </div>
    </ClickAwayListener>
  );
};
